import {
  LOCAL_STORAGE_KEY,
  getValueFromStorageByKey,
} from "@/utils/localStorage";

const isLogin = (state) => state.isLogin;
const user = (state) => state.user;
const userInfo = (state) => state.userInfo;
const permissions = (state) =>
  state.permissions || getValueFromStorageByKey(LOCAL_STORAGE_KEY.PERMISSIONS);
const breadcrumb = (state) => state.breadcrumb;
const appId = (state) => state.appId;
const danhSachLevel = (state) => state.danhSachLevel;
const isIframe = (state) => state.isIframe;

export default {
  isLogin,
  breadcrumb,
  user,
  permissions,
  appId,
  userInfo,
  danhSachLevel,
  isIframe,
};
